import { createHomepageEditorialScene } from './homepage-editorial-scene.js';

// Shopify registry supplies section-local roots and owns load/unload cleanup.
const theme = window.WagmadeTheme;
if (theme) {
  theme.register('homepage-desktop-editorial', '[data-wm-desktop-editorial]', createHomepageEditorialScene);
  theme.init(document);
}
